module.exports = __webpack_public_path__ + "static/media/63.31a6b694.jpg";